define([
    'text!./templates/mfp-leasing-information.html',
], (templateStr) => {
    return [() =>{
        return {
            restrict: 'EA',
            scope: {
                vehicle: '=',
            },
            template: templateStr,
            controller: ['$scope', ($scope) => {
                $scope.leaseContractNumberIsAvailable = () => ($scope.vehicle && $scope.vehicle.additionalInterest && $scope.vehicle.additionalInterest.hasOwnProperty('leaseContractNumber'));
            }],
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPLeasingInformation.js